import React from 'react'

function CardWaveSmile({bgColor = "white", strokeColor="#0044c6"}) {
  return (
      <svg className='wave-separator' preserveAspectRatio="xMinYMax meet" /*width="366" height="34"*/ viewBox="0 0 366 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* <mask id="mask0_3858_184953" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="366" height="34">
              <rect width="366" height="34" fill="#D9D9D9" />
          </mask> */}
          {/* <g mask="url(#mask0_3858_184953)">
              <g filter="url(#filter0_dd_3858_184953)"> */}
                  <path fill={bgColor} d="M0 3.91084L44.4239 13.4629L88.8478 20.627L134.598 27.3135L181.674 28.7463L228.087 26.3583L273.837 21.1046L319.587 12.5077L366 2.95563V34H0V3.91084Z" />
              {/* </g> */}
              <path fill={strokeColor} fillRule="evenodd" clipRule="evenodd" d="M182.983 25.523C238.368 25.3028 294.644 16.2281 366 0V5.82262C294.422 22.101 239.163 31.1223 183.013 31.3456C126.851 31.5689 71.618 23.4774 0 6.30045V0.477828C71.3118 17.5813 127.611 25.7432 182.983 25.523Z" />
          {/* </g> */}
          <defs>
              <filter id="filter0_dd_3858_184953" x="-24" y="-9.04437" width="414" height="79.0444" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy="12" />
                  <feGaussianBlur stdDeviation="12" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.12 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3858_184953" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="1" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0" />
                  <feBlend mode="normal" in2="effect1_dropShadow_3858_184953" result="effect2_dropShadow_3858_184953" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3858_184953" result="shape" />
              </filter>
          </defs>
      </svg>
    
  )
}

export default CardWaveSmile